module.exports = __webpack_public_path__ + "media/images/landkit/icons/payment-methods/verve-735632249fc4c43bdab43d7e537cc0cd.svg";